import React from 'react'
import { compose } from 'recompose'
import { withUpdateGuiMutation } from '../../constants/queries'
import NewsItem from '../blocks/NewsItem'
import NewsPage from './NewsPage'

// bump this number every time the markup in this file is changed
export const PROVIDER_CURRENT_VERSION = 5

interface Props {
  updateGui: (obj: any) => void
}

class ProviderNewsPage extends React.Component<Props> {
  constructor(props) {
    super(props)
    props.updateGui({
      variables: {
        input: { providerNewsVersion: PROVIDER_CURRENT_VERSION },
      },
    })
  }

  render() {
    return (
      <NewsPage>
        <NewsItem date="2019-06-05" title="Progress Note Editing">
          <p>
            Within a predetermined period of time, providers can edit progress
            notes for encounters they have closed - including the text, clinical
            impressions coding (if applicable) and resolution tags.
          </p>
        </NewsItem>
        <NewsItem date="2019-04-10" title="Default Shift Type">
          <p>
            Providers can set a default shift type - either ON DUTY or ON CALL -
            so that future shifts default to that shift type.
          </p>
        </NewsItem>
        <NewsItem date="2019-03-27" title="Default Shift Duration">
          <p>
            Providers can set a default shift duration in settings so that
            future shifts always default to that time period.
          </p>
        </NewsItem>
        <NewsItem date="2019-03-13" title="Provider Participation">
          <p>
            Providers not actively assigned to the encounter can participate in
            the conversation.
          </p>
        </NewsItem>
        <NewsItem date="2019-02-13" title="Clinical Impression Capture">
          <p>
            When staffing certain programs, Clinical Impressions (ICD-10 codes)
            are required when completing a progress note.
          </p>
        </NewsItem>
        <NewsItem
          date="2018-12-12"
          title="Resending Messages, Patient Presence"
        >
          <p>
            Occasionally messages fail to send, so we've added better error
            handling with instructions on how to try sending again.
            Additionally, a green circle encasing the patient avatar indicates a
            patient's online presence.
          </p>
        </NewsItem>
        <NewsItem date="2018-10-24" title="Brand new everything">
          <p>
            We re-wrote the whole thing and will continue to add amazing
            features and functionality over time.
          </p>
        </NewsItem>
        <NewsItem date="2018-10-31" title="New notification settings">
          <p>
            We recently improved how we notify providers with desktop audio
            notifications and SMS/Text notifications.
          </p>
          <p>
            Please navigate to your settings page and ensure your notifications
            settings are set to your liking.
          </p>
        </NewsItem>
      </NewsPage>
    )
  }
}

export default compose<any, any>(withUpdateGuiMutation)(ProviderNewsPage)
